import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from '../directives/module';

import {OrganisationPicker} from './components/organisation-picker/component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
  ],
  declarations: [OrganisationPicker],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
})
export class OrganisationModule {}
